import axiosSelfcareInstance from "./axiosSelfcareInstance";
import {
  CustomerDataType,
  DeviceDataType,
  ChargesDataType,
  DeviceType,
  PriceCheckDataType,
} from "../types/interface";

/*
 * Event API Logger
 * Log events to the event api
 */
export const logSelfcareEventApi = (data: object) => {
  return axiosSelfcareInstance.post("/log/event", data);
};

/*
 * Authenticate User before using other selfcare api services, get csrf token first
 */
export const authenticateUser = async (data: object) => {
  const response = await axiosSelfcareInstance.post(
    "/authentication/login",
    data
  );
  return response;
};

/*
 * Authenticate User with token using other selfcare api services
 */
export const authenticateUserByToken = async (token: string) => {
  const response = await axiosSelfcareInstance.get(
    `/authentication/token_login?token=${token}`
  );
  return response;
};

/*
 * Logout User and clear csrf token, to destroy session
 */
export const logoutUser = async () => {
  const response = await axiosSelfcareInstance.post("/authentication/logout");
  return response;
};

/*
 * POST - Send forgot password email
 */
export const sendForgotPasswordEmail = (data: { email: string }) => {
  return axiosSelfcareInstance.post("/forgotpassword/send/email", data);
};

/*
 * POST - Send forgot password email
 */
export const unsubscribe = (data: { email: string }) => {
  return axiosSelfcareInstance.post("/customers/unsubscribe", data);
};

/*
 * POST - Reset password with token
 */
export const resetPassword = (data: {
  new_password: string;
  token: string;
}) => {
  return axiosSelfcareInstance.post("/forgotpassword/reset/password", data);
};

/*
 * GET - Get username from token
 */
export const getUsernameFromToken = (data: { token: string }) => {
  return axiosSelfcareInstance.get("/forgotpassword/username", {
    params: data,
  });
};

/*
 * Customer calls
 */
export const getCustomerData = async () => {
  return axiosSelfcareInstance.get("/customers");
};

export const getCustomerMessage = async () => {
  return axiosSelfcareInstance.get("/customers/messages");
};

/*
 * Venue Details configs from JSON file on cloud storage
 */
export const getVenueDetailsFromCloudStorage = async () => {
  return axiosSelfcareInstance.get("/customers/config");
};

export const updateCustomerData = async (
  data: CustomerDataType
): Promise<CustomerDataType> => {
  return axiosSelfcareInstance.put("/customers", data);
};
export const saveOfferOneMonth = async (
  data: CustomerDataType
): Promise<CustomerDataType> => {
  return axiosSelfcareInstance.put("/customers/save_offer_onemonth", data);
};

export const inactivateCustomerAccount = async (
  data: CustomerDataType
): Promise<CustomerDataType> => {
  return axiosSelfcareInstance.post("/customers/account_inactivation", data);
};

export const removeDeferredActions = async (data: {
  id: string;
}): Promise<any> => {
  return axiosSelfcareInstance.delete("/customers/deferred_actions", { data });
};

/*
 * Device calls
 */
export const getDeviceData = async (): Promise<DeviceDataType> => {
  return axiosSelfcareInstance.get("/customers/Devices");
};

export const addDevice = async (
  deviceData: Partial<DeviceType>
): Promise<any> => {
  return axiosSelfcareInstance.post("/customers/Devices", deviceData);
};

export const removeDevice = async (deviceId: string): Promise<DeviceType> => {
  return axiosSelfcareInstance.delete(`/customers/Devices/${deviceId}`);
};

export const updateDeviceData = async (
  data: DeviceType
): Promise<DeviceType> => {
  return axiosSelfcareInstance.put(
    `/customers/Devices/${data.device_id}`,
    data
  );
};

/*
 * Charges Receipts calls
 */
export const getChargesData = async (): Promise<ChargesDataType> => {
  return axiosSelfcareInstance.get("/customers/SummaryPayments");
};

export const updateChargesData = async (
  data: ChargesDataType
): Promise<ChargesDataType> => {
  return axiosSelfcareInstance.post("/customers/SummaryPayments/", data);
};

export const emailReceipts = (data: { receipts: (string | undefined)[] }) => {
  return axiosSelfcareInstance.post("/customers/receipts", data);
};

export const priceCheckPreflight = async (
  data: PriceCheckDataType
): Promise<any> => {
  return axiosSelfcareInstance.post("/customers/priceCheck", data);
};

export const updatePromo = async (
  data: PriceCheckDataType
): Promise<any> => {
  return axiosSelfcareInstance.put("/customers/updatepromo", data);
};

export const addFutureProduct = async (
  data: CustomerDataType
): Promise<CustomerDataType> => {
  return axiosSelfcareInstance.post("/customers/add_future_products", data);
};

/*
 * Plan Data calls
 */
export const getPlanData = async () => {
  return axiosSelfcareInstance.get("/customers/plan");
};
